export default function About () {

  return (
    <div>
      <h1>iNotebook</h1>
    </div>
  )
}
